import { useMutation, useQuery } from "@tanstack/react-query";
import { SearchStateDto, StateDto } from "../../../services/dto";
import { IActionResponse, IActionResult } from "../../../assets/utils/lib";
import { StateClient } from "../../../services/proxies/system/stateClient";
import { SystemClient } from "../../../services/proxies/system/systemClient";
import { Constants } from "../../../assets/utils/lib/constants";

export namespace StateService {
  const stateClient = new StateClient();
  const systemClient = new SystemClient();
  export const save = () =>
    useMutation<IActionResult<StateDto>, Error, StateDto>({
      mutationFn: async (payload: StateDto) => {
        return await stateClient.saveStateAsync(payload);
      },
    });

  export const getStateQuery = (stateId: string | undefined) =>
    useQuery({
      queryKey: ["stateQuery", stateId],
      queryFn: async () => await stateClient.getStateAsync(stateId),
      enabled: Boolean(stateId && stateId !== Constants.emptyGuid),
    });

  export const gridQuery = (searchQuery: SearchStateDto) =>
    useQuery({
      queryKey: ["stateGridQuery", searchQuery],
      queryFn: async () => await stateClient.searchStateAsync(searchQuery),
      placeholderData: (previousData) => previousData,
    });

  export const regionLookupQuery = () => {
    return useQuery({
      queryKey: ["regionLookupQuery"],
      queryFn: async () => {
        const result = await systemClient.getRegionlookupQuery();
        return result;
      },
    });
  };

  export const deleteState = () =>
    useMutation<IActionResponse, Error, string>({
      mutationFn: async (id: string | undefined) => {
        return await stateClient.deleteStateAsync(id);
      },
    });
}
